import React from "react";

export default function PaperPlane(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 16 16"
         fill="currentColor"
         height="1em"
         width="1em"
         {...props}
    >
      <path d="M15.5661407.17510589c.3156648.21873302.4813108.59682866.4219283.97492431L13.9878163 14.149021c-.0468809.3031015-.2312792.5687059-.5000631.7186942-.268784.1499884-.5906996.1687369-.8751105.0499961l-3.94737357-1.6404976-1.25328329 2.3279443c-.16252052.3031014-.50943934.4562145-.84385657.3718461-.33441724-.0843685-.56882184-.3843452-.56882184-.7280685v-2.9997671c0-.1656121.0562571-.3280995.15939513-.4593393L11.32498 5.14659492c.0781349-.22185777-.2031506-.44684031-.4063013-.26247962L5.32422217 9.94309754l-1.00012631.90305486c-.28753632.2593549-.69696303.3312243-1.05638342.181236L.61112692 9.92122424c-.3500442-.1468636-.5875742-.47808789-.60945197-.85930829-.02187776-.3812204.17189671-.7405675.50318855-.93117771L14.5066319.13135928c.3344172-.1906102.7469693-.17186165 1.0626342.0437466h-.0031254Z"/>
    </svg>
  );
}
